import styled from "styled-components";

export const DeleteAccountContainer = styled.div`
  display: flex;
  max-width: 428px;
  justify-content: center;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 744px) {
    max-width: 744px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const TitlePage = styled.h1`
  text-align: center;
  font-size: 20px;

  @media (min-width: 744px) {
    font-size: 32px;
  }
`;

export const List = styled.ol`
  font-size: 20px;
  @media (min-width: 755px) {
    font-size: 32px;
  }
`;

export const ListItem = styled.li`
  margin-top: 20px;

  &:nth-child(1) {
    margin-top: 0px;
  }
`;

export const ListItemText = styled.p`
  font-size: 20px;
  @media (min-width: 744px) {
    font-size: 32px;
  }
`;

export const ContainerIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 20px;
  @media (min-width: 744px) {
    font-size: 32px;
  }
`;
